<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Listado de Inmuebles de {{ $page.props.auth.user.first_name }}</h1>
    <div class="mb-6 flex justify-between items-center" v-if="properties.data.length != 0">
      <search-filter v-model="form.search" :show-filter="true" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
        

        <div  class="grid xl:grid-cols-3 md:grid-cols-2 md:px-8 md:py-12 md:gap-x-8 md:py-16" >
        <div v-for="property in properties.data" :key="property.id">
            <property-card :property="property" :property-type="propertyType" :location="location" />

        </div>
        <div v-if="properties.data.length === 0">
          No se encontraron inmuebles asociados a su cuenta.
        </div>
        </div>

        
      <!-- </table> -->
    </div>
    <pagination class="mt-6" :links="properties.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import PropertyCard from '@/Shared/PropertyCard'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import locationData from "@/Shared/locations.json";
import propertyType from "@/Shared/propertyType.json";

export default {
  metaInfo: { title: 'Inmuebles' },
  components: {
    Icon,
    Pagination,
    PropertyCard,
    SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,
    properties: Object,
  },
  data() {
    return {
      location: locationData,
      propertyType,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('properties'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
